<ng-container *transloco="let t">
  <form>
    <app-statistics-view [loading]="loading">

      <div title>
        <h1>
          <span>{{ t('statistics.acs.competences') }}</span>
        </h1>
      </div>

      <div filter>
        <app-ac-competence-filter (filterSet)="onFilterSet($event)"></app-ac-competence-filter>
      </div>

      <div details>
        <ng-container *ngIf="set === true">
          <p *ngIf="acAmount > 0">{{ t('statistics.acs.ac_amount') }}: <strong>{{ acAmount }}</strong></p>
          <div class="p-grid">
            <ng-container *ngIf="acAmount > 0 && recommendations !== null">
              <div [ngClass]="bigChart === true ? 'p-col-6' : 'p-col-4'">
                <app-ac-recommendations-chart [data]="recommendations"></app-ac-recommendations-chart>
              </div>
            </ng-container>
            <ng-container *ngIf="chartData?.length > 0">
              <div [ngClass]="bigChart === true ? 'p-col-6' : 'p-col-4'" *ngFor="let data of chartData">
                <app-ac-competence-overview-chart [data]="data" (barClicked)="onBarClicked($event)"></app-ac-competence-overview-chart>
              </div>
            </ng-container>
          </div>
          <div *ngIf="chartData?.length === 0">
            <p class="p-text-center p-mt-4">
              <fa-icon [icon]="faBoxOpen"></fa-icon><br>
              {{ t('common.labels.nodata') }}
            </p>
          </div>
        </ng-container>
        <ng-container *ngIf="set !== true">
          <p class="p-text-center p-mt-4">
            <fa-icon [icon]="faSlidersH"></fa-icon><br>
            <span [innerHTML]="t('common.labels.set_filter_min_proc')"></span>
          </p>
        </ng-container>
      </div>

    </app-statistics-view>

    <p-dialog [header]="t('statistics.acs.rating_dispersion')" [(visible)]="drilldownOpened" [draggable]="false" [resizable]="false" modal="true" [style]="{ width: '50vw' }">
      <app-ac-competence-filter (filterSet)="onDetailFilterSet($event)" [values]="filterValues" #detailFilter></app-ac-competence-filter>
      <hr>
      <app-ac-competence-detail-chart [data]="drilldownData"></app-ac-competence-detail-chart>
    </p-dialog>

  </form>
</ng-container>
